import { authenticatedInstance } from 'api';
import { triggerToast } from 'redux/actions/ui';

export const GET_AFFILIATE_SUMMARY = {
  STARTED: 'GET_AFFILIATE_SUMMARY_STARTED',
  SUCCESS: 'GET_AFFILIATE_SUMMARY_SUCCESS',
  FAIL: 'GET_AFFILIATE_SUMMARY_FAIL',
};

export const GET_AFFILIATE_REFERRALS = {
  STARTED: 'GET_AFFILIATE_REFERRALS_STARTED',
  SUCCESS: 'GET_AFFILIATE_REFERRALS_SUCCESS',
  FAIL: 'GET_AFFILIATE_REFERRALS_FAIL',
};

export const GET_AFFILIATE_COMMISSION = {
  STARTED: 'GET_AFFILIATE_COMMISSION_STARTED',
  SUCCESS: 'GET_AFFILIATE_COMMISSION_SUCCESS',
  FAIL: 'GET_AFFILIATE_COMMISSION_FAIL',
};

const API_ENDPOINTS = {
  AFFILIATE_SUMMARY: '/api/Affiliate_Summary',
  AFFILIATE_REFERRALS: '/api/My_Affiliate',
  AFFILIATE_COMMISSION: '/api/Affiliate_Commission',
};

const fetchAffilateData = (url, successType, failType) => {
  return async (dispatch) => {
    dispatch({ type: successType.STARTED });

    try {
      const { data } = await authenticatedInstance({
        url,
        method: 'GET',
      });

      if (data.status === 'Success') {
        dispatch({
          type: successType.SUCCESS,
          payload: data.data,
        });
      } else {
        dispatch({ type: failType });
      }
    } catch (e) {
      dispatch({ type: failType });
      dispatch(triggerToast('somethingWentWrong'));
    }
  };
};

export const loadAffiliateSummary = () =>
  fetchAffilateData(API_ENDPOINTS.AFFILIATE_SUMMARY, GET_AFFILIATE_SUMMARY, GET_AFFILIATE_SUMMARY.FAIL);
export const loadAffiliateReferrals = () =>
  fetchAffilateData(API_ENDPOINTS.AFFILIATE_REFERRALS, GET_AFFILIATE_REFERRALS, GET_AFFILIATE_REFERRALS.FAIL);
export const loadAffiliateCommission = () =>
  fetchAffilateData(API_ENDPOINTS.AFFILIATE_COMMISSION, GET_AFFILIATE_COMMISSION, GET_AFFILIATE_COMMISSION.FAIL);
